


























import {
  Subject,
  SubjectType,
  SubjectTypeFriendlyValue,
} from '@/resource/subject/subject.model';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ModalPreCollectionNotAvail from '@/components/modals/ModalPreCollectionNotAvail.vue';
import getEnumValue from '@/utils/common/get-enum-value';

@Component({
  components: { ModalPreCollectionNotAvail },
})
export default class PreCollectionNotAvail extends Vue {
  @Prop({ required: true })
  selectedSubject!: Subject;

  @Prop({ required: true })
  selectedType!: SubjectType;

  showNotAvailModal = false;

  requestClick() {
    this.showNotAvailModal = true;
  }

  closePdfOnlyModal() {
    this.showNotAvailModal = false;
  }

  get description() {
    return `Papers for ${this.selectedSubject.name} ${getEnumValue(
      this.selectedType,
      SubjectTypeFriendlyValue,
    )} are coming soon. We are still creating papers for this subject.
     Let us know if you need this subject ASAP by clicking the button below.`;
  }
}
